/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RoutePlanManualReasonEnum =
  (typeof RoutePlanManualReasonEnum)[keyof typeof RoutePlanManualReasonEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoutePlanManualReasonEnum = {
  NoReturnTransit: 0,
  SpanExceedsLimit: 1,
  HubBacklogGrowing: 2,
  MissingCoordinates: 3,
  ReservedByPlanner: 4,
  DrivingPolicyBlocked: 5,
  NoCandidate: 6,
  HotelNotPossible: 7,
  ReturnLegNeedsCustomerRebooking: 8,
  OutboundTransitUnreasonable: 9,
  OutboundHubStopoverNeedsReview: 10,
  PredecessorLegNotPlanned: 11,
  AcquisitionNotCompleted: 12,
  PostalBoxAddress: 13,
  EmergencyCapability: 14,
  RequiresCustomerRebooking: 15,
  NightDriving: 16,
  TransferTransitTooLate: 17,
  MissesExistingAssignment: 18,
  MultiCarPurchase: 19,
  DayExceedsMaxWorkingHours: 20,
} as const;
